module.exports = __webpack_public_path__ + "media/images/flags/32/Northern-Mariana-Islands-55837ae244451a007028745d626fdbe1.png";